module.exports = __webpack_public_path__ + "img/login.37661c04.webp";